import { ApiService } from "@/domain/clients";
import { Endpoints } from "@/infra/api";
import { UserResponse } from "../../dtos/responses";
import { AuthDataSource } from "./AuthDataSource";
import { LoginCredentials } from "@/domain/entities";
import { commonSchemas, ValidationUtils } from "@/infra/utils/validation";
import { LoginCredentialsSchema } from "@/data/schemas";

export class AuthRemoteDataSource implements AuthDataSource {
  constructor(private readonly apiService: ApiService) {}

  async login(params: LoginCredentials): Promise<{
    data: UserResponse;
    access_token: string;
  }> {
    ValidationUtils.validate(LoginCredentialsSchema, params);
    const { data, access_token } = await this.apiService.post<
      UserResponse,
      LoginCredentials
    >(Endpoints.login, params);

    if (!data || !access_token) {
      throw new Error("Ocorreu um erro ao fazer login");
    }

    return { data, access_token };
  }

  async checkSignupActive(): Promise<{ active: boolean }> {
    const response = await this.apiService.get<{ active: boolean }>(
      Endpoints.psy_signup_active,
    );
    return { active: !!response.data?.active };
  }

  async sendRecoveryEmail(email: string): Promise<{ message: string }> {
    ValidationUtils.validate(commonSchemas.email, email);
    const { message } = await this.apiService.post(
      Endpoints.send_recovery_email,
      { email },
    );

    return {
      message:
        message ||
        "Se o email existir, você receberá um link para redefinir sua senha.",
    };
  }
}
